import React from 'react';
import { Button } from "reactstrap";

function AddConcept(props) {
    const { toggle } = props && props;
    return (
        <div className="text-center">
            <Button className="--btn-primary" onClick={toggle}>
                <i className="fa fa-plus mr-2" aria-hidden="true"></i>Add Concept
            </Button>
        </div>
    );
};

export default AddConcept;